import {ApiOrderRepository} from '@infra/domain/model/Order/ApiOrderRepository';
import {ApiPlaceOrderRepository} from '@infra/domain/model/Order/ApiPlaceOrderRepository';
import {ApiCancelBoxRepository} from '@infra/domain/model/Order/CancelBox/ApiCancelBoxRepository';

import {CancelBox} from './CancelBox';
import {CancelOrder} from './CancelOrder';
import {UpdateOrderComment} from './UpdateOrderComment';
import {ApplyPromoCode} from './ApplyPromoCode';
import {RemovePromoCode} from './RemovePromoCode';

export const OrderApplication = {
  cancelBox: CancelBox(ApiCancelBoxRepository),
  cancelOrder: CancelOrder(ApiOrderRepository),
  updateOrderComment: UpdateOrderComment(ApiOrderRepository),
  applyPlaceOrderPromoCode: ApplyPromoCode(ApiPlaceOrderRepository),
  removePlaceOrderPromoCode: RemovePromoCode(ApiPlaceOrderRepository),
};
